import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const menuTemplate = document.createElement('template')
menuTemplate.innerHTML = `
    <wa-button
      size="small"
      appearance="plain"
      variant="neutral"
      aria-haspopup="true"
      aria-expanded="false"
      aria-controls="profile-dropdown"
      class="section-btn"
      with-caret
    >
      <slot name="buttonText"></slot>
    </wa-button>
`

class NavHeaderContextualNewSubMenuButton extends HTMLElement {
  private button: HTMLElement | null = null
  private isExpanded: boolean = false

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(menuTemplate.content.cloneNode(true))
  }

  connectedCallback() {
    this.button = this.shadowRoot?.querySelector('wa-button') || null

    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this))
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleClick.bind(this))
    }
  }

  private handleClick(event: Event) {
    event.preventDefault()
    event.stopPropagation()

    this.toggleSubMenu()
  }

  private toggleSubMenu() {
    this.isExpanded = !this.isExpanded

    // Update aria-expanded attribute
    if (this.button) {
      this.button.setAttribute('aria-expanded', this.isExpanded.toString())
    }

    // Toggle parent container appearance
    this.toggleParentContainerAppearance()

    // Find the transition container in the parent DOM
    const transitionContainer = this.findSubMenuContainer()

    if (transitionContainer) {
      if (this.isExpanded) {
        this.showSubMenu(transitionContainer)
      } else {
        this.hideSubMenu(transitionContainer)
      }
    }
  }

  private findSubMenuContainer(): HTMLElement | null {
    // Navigate up the DOM to find the sub menu container
    let current = this.parentElement
    while (current) {
      // Look for the next sibling transition element with class "inner-sub-menu-container"
      const nextSibling = current.nextElementSibling
      if (nextSibling && nextSibling.classList.contains('inner-sub-menu-container')) {
        return nextSibling as HTMLElement
      }
      current = current.parentElement
    }
    return null
  }

  private showSubMenu(container: HTMLElement) {
    // Make it visible
    container.style.display = 'flex'
    container.style.opacity = '0'
    container.style.transform = 'translateY(-10px)'

    // Force reflow
    void container.offsetHeight

    // Apply show animation
    container.style.transition = 'all 0.3s ease'
    container.style.opacity = '1'
    container.style.transform = 'translateY(0)'
  }

  private hideSubMenu(container: HTMLElement) {
    container.style.transition = 'all 0.3s ease'
    container.style.opacity = '0'
    container.style.transform = 'translateY(-10px)'

    // Hide the element after animation completes
    setTimeout(() => {
      if (!this.isExpanded) {
        container.style.display = 'none'
        // Reset inline styles
        container.style.opacity = ''
        container.style.transform = ''
        container.style.transition = ''
      }
    }, 300)
  }

  private toggleParentContainerAppearance() {
    // Find the parent container with class 'sub-menu-item-separator'
    let current = this.parentElement
    while (current) {
      if (current.classList.contains('sub-menu-item-separator')) {
        if (this.isExpanded) {
          current.classList.add('active')
        } else {
          current.classList.remove('active')
        }
        break
      }
      current = current.parentElement
    }
  }
}

customElements.define(
  'ts-navheader-contextual-new-sub-menu-button',
  NavHeaderContextualNewSubMenuButton,
)
